import React from 'react';
import './style.scss';

export const DomesticRealEstatePositionHeader = () => {
  return (
    <>
      <div className="domesticRealEstatePositionHeader">
        <div className="domesticRealEstatePositionHeader_realEstateName">物件名</div>
        <div className="domesticRealEstatePositionHeader_transferDate">取得日</div>
        <div className="domesticRealEstatePositionHeader_firstTransferQuantity">購入個数</div>
        <div className="domesticRealEstatePositionHeader_firstTransferRealEstatePrice">購入価格</div>
        <div className="domesticRealEstatePositionHeader_currentQuantity">現在保有個数</div>
        <div className="domesticRealEstatePositionHeader_currentRealEstatePrice">現在保有価格</div>
        <div className="domesticRealEstatePositionHeader_holdingPeriod">保有期間</div>
        <div className="domesticRealEstatePositionHeader_inheritanceTaxAssessment">
          <span>相続税評価額</span>
          <span>/1,000万円あたり（円）</span>
        </div>
        <div className="domesticRealEstatePositionHeader_inheritanceTaxAssessmentSmallResidence">
          <span>相続税評価額</span>
          <span>（小規模宅地）（円）</span>
        </div>
        <div className="domesticRealEstatePositionHeader_dividendYield">
          <span>配当利回り</span>
          <span>（想定）（%）</span>
        </div>
        <div className="domesticRealEstatePositionHeader_contract">契約関連書類</div>
      </div>
    </>
  );
};
